import React from 'react';
import { FiHeadphones, FiMail, FiMapPin, FiPhoneCall } from 'react-icons/fi';
import { HiOutlineOfficeBuilding, HiOutlineMail } from 'react-icons/hi';
import { TbReportMoney } from 'react-icons/tb';
import { FaFax } from 'react-icons/fa';

export const content = {
  infoCards: [
    {
      icon: <FiHeadphones />,
      title: <>Question or concern? <br/> Talk to us in more detail:</>,
      info: [
        {
          type: <FiPhoneCall />,
          data: '(214) 550-9888',
          href: 'tel:+12145509888',
        },
        // {
        //   type: <FaFax />,
        //   data: '863-510-5974',
        //   href: null,
        // },
        {
          type: <HiOutlineMail />,
          data: 'hello@atlanticlabs.net',
          href: 'mailto:hello@atlanticlabs.net',
        },
      ],
      desc: null,
    },
    // {
    //   icon: <TbReportMoney />,
    //   title: 'For Billing Inquiries or Concerns:',
    //   info: [
    //     {
    //       type: <FiPhoneCall />,
    //       data: '813-376-4353',
    //       href: 'tel:+18133764353',
    //     },
    //     {
    //       type: <HiOutlineMail />,
    //       data: 'billing@atlanticlabs.net',
    //       href: 'tel:+12145509888',
    //     },
    //   ],
    //   desc: '',
    // },
    {
      icon: <FiMapPin />,
      title: 'Atlantic Labs',
      info: [
        {
          type: null,
          data: '5757 Alpha Rd Suite #100 Dallas, TX 75240',
          href: 'https://www.google.com/maps/place/5757+Alpha+Rd+%23100,+Dallas,+TX+75240/@32.9332957,-96.8089888,17z/data=!3m1!4b1!4m5!3m4!1s0x864c20e14dfed26b:0x252190e634046c2a!8m2!3d32.9332957!4d-96.8089888',
          target: '_blank'
        },
      ],
      desc: 'Monday-Friday 9am - 7pm (CST)',
    }
  ],

  formAreaContent: {
    title: 'Write Us a Message'
    // To change data on the form, go to /content/formControl.js
  },
};

// {
//   type: "phones",
//   icon: <FiHeadphones/>,
//   title: "For Direct/Immediate Service",
//   info:[
//     {
//       type: "Call",
//       number: "866-571-1383",
//       href: "tel:+18665711383",
//     }
//   ],
//   desc:"Monday-Friday 9am - 7pm (EST)"
// },
// {
//   type: "phones",
//   icon: <FiHeadphones/>,
//   title: "Courier Service – Arrange for Specimen Pickups or Supplies",
//   info:[
//     {
//       type: "Call",
//       number: "813-376-4353",
//       href: "tel:+18133764353"
//     },
//     {
//       type: "Call",
//       number: "(214) 550-9888",
//       href: "tel:+12145509888"
//     },
//   ],
//   desc:""
// },
// {
//   type: "phones",
//   icon: <FiHeadphones/>,
//   title: "Billing – For Inquiries Regarding Fees or Any Billing Concerns",
//   info:[
//     {
//       type: "Call",
//       number: "(214) 550-9888",
//       href: "tel:+12145509888"
//     },
//     {
//       type: "Call",
//       number: "(214) 550-9888",
//       href: "tel:+18777690669"
//     },
//   ],
//   desc:""
// },
// {
//   type: "emails",
//   icon: <FiMail/>,
//   title: "Our Email Address",
//   info:[
//     {
//       email: "wmoschetto@Atlantic Labslab.com",
//       href: "mailto:wmoschetto@Atlantic Labslab.com"
//     }
//   ],
//   desc:"CEO / President"
// },
// {
//   type: "phones",
//   icon: <HiOutlineOfficeBuilding/>,
//   title: "Main Office – Request Reports or to Speak to a Pathologist",
//   info:[
//     {
//       type: "Call",
//       number: "(214) 550-9888",
//       href: "tel:+12145509888"
//     },
//     {
//       type: "Call",
//       number: "813-376-4353",
//       href: "tel:+18133764353"
//     },
//     {
//       type: "Fax",
//       number: "863-510-5974",
//       href: null
//     }
//   ],
//   desc:""
// },
// {
//   type: "addresses",
//   icon: <FiMapPin/>,
//   title: "Pathology Laboratory",
//   info:[
//     {
//       address: "705 N. Lake Parker Ave., Lakeland Florida, 33801",
//       office: "Office: 866-571-1383",
//       hours: "Monday-Friday 9am - 7pm (EST)",
//       call: "Call: 877-769-0669"
//     }
//   ],
//   desc:""
// }
